export const disableDesign = (designClassName: string) => {
  document.documentElement.classList.remove(designClassName);
};
